export const getComponentName = (component) =>
  component.displayName || component.name

export const invokeEach =
  (...args) =>
  (...fns) => {
    for (const fn of fns) {
      if (typeof fn === 'function') {
        fn(...args)
      }
    }
  }

export const removeProps = (propNames: string[]) => (props: object) =>
  Object.keys(props).reduce(
    (acc, key) =>
      propNames.indexOf(key) < 0 ? { ...acc, [key]: props[key] } : acc,
    {}
  )

/**
 *
 * Composes a series of single argument functions from right to left (e.g.
 * `compose(f, g, h)(2)` is equivalent to `f(g(h(2)))`).
 *
 * If no arguments are given, it returns an identity function.
 *
 * @param {function} args
 */
export const compose =
  (...args) =>
  (arg) =>
    args.reduceRight((acc, next) => next(acc), arg)

// Got this from from preact-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(a, b) {
  for (const i in a) {
    if (!(i in b)) {
      return true
    }
  }
  for (const i in b) {
    if (a[i] !== b[i]) {
      return true
    }
  }
  return false
}

export function memoizeOnce<S, T>(func: (arg: S) => T): (arg: S) => T {
  let cachedArg: S
  let cachedValue: T

  return function memoized(arg: S): T {
    if (shallowDiffers(cachedArg || {}, arg)) {
      cachedArg = arg
      cachedValue = func(arg)
    }

    return cachedValue
  }
}

export const monotonic = (interval = 1) => {
  let i = 0
  return () => (i += interval)
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

export type { SubmitFormItem } from './submit-form'
export { submitForm } from './submit-form'

export const isEmpty = (value) => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )
}
